import { datadogRum } from '@datadog/browser-rum';
import { DatadogLogger } from './datadog-logger.helper';
import { LogType } from '../types/logType';

// Single call site for "this happened" telemetry — sends to RUM (as a
// queryable action/error, visible in the Explorer, not just replay video)
// and to Logs (existing DatadogLogger pipeline), so a screen/error is never
// only findable by watching a session replay.
export function reportEvent(
  name: string,
  context: Record<string, unknown>,
  type: LogType = LogType.INFO,
): void {
  // Each channel gets its own guard — a RUM SDK failure must not also
  // swallow the Logs write (and vice versa).
  try {
    if (type === LogType.ERROR) {
      datadogRum.addError(name, context);
    } else {
      datadogRum.addAction(name, context);
    }
  } catch {
    // Datadog must never break the liveness flow
  }
  try {
    DatadogLogger.Log(name, context, type);
  } catch {
    // Datadog must never break the liveness flow
  }
}
